import { Injectable } from '@angular/core';
import { CheckinBaseClass } from '../../components';
import {
  StandbyGetAlternativeOffersState,
  resetStandbyGetAlternativeOffers,
  setStandbyGetAlternativeOffersFromApi,
  selectStandbyGetAlternativeOffersIsFailureStatus,
  selectStandbyGetAlternativeOffersResponse,
  selectStandbyGetAlternativeOffersState,
} from '../../store/standby-get-alternative-offers';
import { Store, select } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import {
  DefaultService as Api,
  PostStandbyGetAlternativeOffersRequest,
  PostStandbyGetAlternativeOffersResponse,
} from 'src/sdk_checkin';

@Injectable()
export class StandbyGetAlternativeOffersStoreService extends CheckinBaseClass {
  private _result$: Observable<StandbyGetAlternativeOffersState>;
  private _result!: StandbyGetAlternativeOffersState;
  get result() {
    return this._result;
  }

  /** APIエラーSubscription */
  apiErrorResponseSubscription?: Subscription;

  constructor(private _store: Store<StandbyGetAlternativeOffersState>, private api: Api) {
    super();
    this._result$ = this._store.pipe(
      select(selectStandbyGetAlternativeOffersState),
      filter((data) => !!data)
    );
    this.subscribeService(this._result$, (data) => {
      this._result = data;
    });
  }

  override destroy(): void {
    if (!!this.apiErrorResponseSubscription) {
      this.apiErrorResponseSubscription.unsubscribe();
      this.apiErrorResponseSubscription = undefined;
    }
  }

  /**
   * GetAlternativeOffersStateStore のObservableを返却する
   * @returns GetAlternativeOffersStateStore の全ての値を取得するObservable
   */
  public getResultState$() {
    return this._result$.pipe(filter((state) => !!state.model));
  }

  /**
   * API呼び出しが失敗したかのObservableを返却する
   * @returns isFailureの値を取得するObservable
   */
  public getIsFailure$() {
    return this._store.pipe(
      select(selectStandbyGetAlternativeOffersIsFailureStatus),
      filter((state) => !!state)
    );
  }

  /**
   * 空席待ち候補便照会が正常終了したら結果を取得するObservable
   */
  public getResultStateIfSuccessful$() {
    return this._result$.pipe(filter((state) => !state.isFailure && !state.isPending && !!state.model));
  }

  /**
   * API呼び出し結果のObservableを受け取りStoreに格納する
   * @param call API呼び出し結果を取得するObservable
   */
  private setResult(call: Observable<PostStandbyGetAlternativeOffersResponse>) {
    this._store.dispatch(setStandbyGetAlternativeOffersFromApi({ call }));
  }

  /**
   * 空席待ち候補便照会のストアをクリアする
   */
  public clear() {
    this._store.dispatch(resetStandbyGetAlternativeOffers());
  }

  /**
   * 空席待ち候補便照会APIの呼び出しと、呼び出し結果のStoreへの設定を行う
   */
  public callApi(condition: PostStandbyGetAlternativeOffersRequest) {
    const call = this.api.standbyGetAlternativeOffersPost(condition);
    this.setResult(call);
  }

  /**
   * 空席待ち候補便照会APIのResponse modelを取得
   */
  public getResponse$() {
    return this._store.pipe(
      select(selectStandbyGetAlternativeOffersResponse),
      filter((state) => !!state)
    );
  }
}
